import { UnderTitleMessageType } from '@/enums/messageEnum'
export interface State {
  pageMessages: string[]
  messageType: UnderTitleMessageType
  ballonMessageLastType: string
}

const state = (): State => ({
  pageMessages: [],
  messageType: UnderTitleMessageType.ERROR,
  ballonMessageLastType: '',
})

export default state
